export const COLUMN_WIDTH = 40;    // px per day
export const ROW_HEIGHT = 36;      // compact row height
export const TASK_BAR_HEIGHT = 24; // task bar height
export const TIMELINE_DAYS = 60;   // visible days on timeline
export const LABEL_EVERY_N_DAYS = 7;

export const RESIZE_HANDLE_PX = 5;
export const MIN_TASK_DURATION_DAYS = 1;
